interface SlideToggleCallback {
  // eslint-disable-next-line no-use-before-define
  (event: Event, slideToggle: SlideToggleComponent): void;
}

class SlideToggleComponent {
  public element: HTMLElement;

  private value: boolean = false;

  public constructor(element: HTMLElement, callback: SlideToggleCallback) {
    this.element = element;
    this.initValue();
    this.bindCallback(callback);
  }

  private initValue = (): void => {
    const attributeValue = this.element.getAttribute('aria-checked') === 'true';
    this.setValue(attributeValue);
  };

  private bindCallback = (callback: SlideToggleCallback): void => {
    this.element.addEventListener('click', (event: Event) => {
      this.switchValue();
      callback(event, this);
    });
  };

  private render = (): void => {
    this.element.setAttribute('aria-checked', this.value ? 'true' : 'false');
  };

  public switchValue = (): void => {
    this.value = !this.value;
    this.render();
  };

  public setValue = (value: boolean): void => {
    this.value = value;
    this.render();
  };

  public getValue = (): boolean => this.value;
}

export default SlideToggleComponent;
